import React from "react";
import { ContractProvider } from "./contexts/ContractContext";
import { PolicyCancellationProvider } from "./contexts/PolicyCancellationContext";
import { DialogProvider } from "./utils/DialogProvider";
import { ApiErrorModalProvider } from "./contexts/ApiErrorModalContext";
import { PackagePaymentModalProvider } from "./contexts/PackagePaymentModalContext";
import PackagePaymentModal from "./components/payment/PackagePaymentModal";

export const AppProviders = ({ children }) => {
	return (
		<DialogProvider Component={() => (
			<ApiErrorModalProvider>
				<ContractProvider>
					<PolicyCancellationProvider>
						<PackagePaymentModalProvider>
							<PackagePaymentModal />
							{children}
						</PackagePaymentModalProvider>
					</PolicyCancellationProvider>
				</ContractProvider>
			</ApiErrorModalProvider>
		)} />
	);
};
